import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../atoms/Button';
import OrderDetail from '../OrderDetail';
import { OrderOut } from '../../../types/api';
import './OrderDetailModal.scss';

interface OrderDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  order: OrderOut | null;
  onOrderUpdate?: (updatedOrder: OrderOut) => void;
  eventName?: string;
  venueName?: string | null;
}

const OrderDetailModal: React.FC<OrderDetailModalProps> = ({
  isOpen,
  onClose,
  order,
  onOrderUpdate,
  eventName,
  venueName
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen || !order) return null;

  return createPortal(
    <div className="order-detail-modal-overlay" onClick={onClose}>
      <div className="order-detail-modal" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <div className="order-detail-modal__bar">
          <Button
            variant="outline"
            size="sm"
            onClick={onClose}
            className="order-detail-modal__close"
          >
            {t('bartender.orderDetail.close')}
          </Button>
        </div>
        <div className="order-detail-modal__body">
          <OrderDetail
            order={order}
            onOrderUpdate={onOrderUpdate}
            eventName={eventName}
            venueName={venueName}
          />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default OrderDetailModal;
